<template>
  <div class="fileArea">
    <!--附件-->
    <div class="fileBox" v-if="ifFile" @touchstart="gotouchstart" @touchmove="gotouchmove"
         @touchend="gotouchend">
      <div>
        <div>
          <p class="fileName">{{ fileInfo.csdrAttName }}</p>
          <!--          <p class="fileSize">482 KB</p>-->
        </div>
      </div>
      <img :src="currentIcon" alt="图标" class="fileIcon">
    </div>
    <!--图片-->
    <img :src="$originApi+fileInfo.csdrAtt" @click="showImg" class="imgMsgFile" v-if="!ifFile">
    <!--下载等按钮弹框-->
    <div class="btnArea" v-show="showBtnBox && !ifDisableDownBtn">
      <van-button type="default" class="itemBtn" size="small" @click="downloadFile" :disabled="ifDisableDownBtn"
      >
        <span v-show="!ifDisableDownBtn">下载</span>
        <!--        <span v-show="ifDisableDownBtn">禁止下载</span>-->
      </van-button>
    </div>

  </div>
</template>

<script>
import {ImagePreview, Toast} from 'vant'
import {downloadUrlToBlob} from '../../assets/js/common'

export default {
  name: 'attachment',
  props: ['fileInfo'],
  data () {
    return {
      ifFile: true, // 是否是附件类型
      fileType: '', // 当前文件类型
      fileName: '', // 当前文件名字
      currentIcon: '', // 当前文件图片
      showBtnBox: false, // 是否显示撤回按钮弹窗
      ifDisableDownBtn: false, // 是否禁用下载按钮
      timeOut: null, // 长按计时器
      fileIcon: [{
        type: 'pdf',
        icon: require('../../assets/img/pdf.png')
      }, {
        type: 'docx',
        icon: require('../../assets/img/word.png')
      }, {
        type: 'doc',
        icon: require('../../assets/img/word.png')
      }, {
        type: 'xlsx',
        icon: require('../../assets/img/excel.png')
      }, {
        type: 'xls',
        icon: require('../../assets/img/excel.png')
      }, {
        type: 'zip',
        icon: require('../../assets/img/zip.png')
      }]
    }
  },
  methods: {
    // 判断是图片还是文件
    checkFileType () {
      let imgType = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp', 'tif']

      let fileNameInfo = this.fileInfo.csdrAttName
      let fileNameStr = fileNameInfo.substring(0, fileNameInfo.lastIndexOf('.'))
      let fileTypeStr = fileNameInfo.substring(fileNameInfo.lastIndexOf('.') + 1)

      this.fileName = fileNameStr
      this.fileType = fileTypeStr
      if (imgType.indexOf(fileTypeStr) === -1) {
        this.ifFile = true
        // 匹配附件图标
        this.checkFileIcon()
      } else {
        this.ifFile = false
      }
    },
    // 匹配附件图标
    checkFileIcon () {
      this.fileIcon.forEach(item => {
        if (item.type === this.fileType) {
          this.currentIcon = item.icon
        }
      })
    },
    // 查看大图
    showImg () {
      ImagePreview([this.$originApi + this.fileInfo.csdrAtt])
    },
    // 附件预览
    preview () {
      this.$router.push({
        name: 'attachmentPreview',
        query: {
          file: JSON.stringify(this.fileInfo)
        }
      })
    },
    // 手指按下事件
    gotouchstart () {
      window.isClick = true
      clearTimeout(this.timeOut)
      let that = this
      this.timeOut = setTimeout(function () {
        // 此处长按操作
        window.isClick = false
        that.showBtnBox = true
        that.$store.commit('setShowAllBtn', true)
      }, 500)
      // 清除默认长按事件
      document.oncontextmenu = function () {
        return false
      }
    },
    // 手释放，如果在500毫秒内就释放，则取消长按事件，此时将执行onclick应该执行的事件
    gotouchend () {
      if (window.isClick) {
        // 此处执行点击事件
        this.preview()
      }
    },
    // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove () {
      window.isClick = false
    },
    // 下载附件
    downloadFile () {
      if (!this.fileInfo.csdrAtt || this.fileInfo.csdrAtt === null || this.fileInfo.csdrAtt === '') {
        Toast.fail('无下载地址')
        this.showBtnBox = false
      } else {
        let url = ''
        if (this.fileInfo.csdrAtt.indexOf('http') === -1) {
          url = this.$originApi + this.fileInfo.csdrAtt
        } else {
          url = this.fileInfo.csdrAtt
        }
        downloadUrlToBlob(url, this.fileName, this.fileType)
        this.showBtnBox = false
      }
    },
    // 是否禁用下载
    ifDisableDownFn () {
      if (this.fileInfo.csdrAttDownload) {
        this.ifDisableDownBtn = false
      } else {
        this.ifDisableDownBtn = true
      }
    }
  },
  mounted () {
    // 判断是图片还是文件
    this.checkFileType()
    // 是否禁用下载
    this.ifDisableDownFn()
  },
  computed: {
    showAllBtn () {
      return this.$store.state.showAllBtn
    }
  },
  watch: {
    fileInfo: {
      handler (newValue, oldValue) {
        this.$forceUpdate()
      },
      immediate: true,
      deep: true
    },
    showAllBtn: {
      handler (newValue, oldValue) {
        if (newValue === false) {
          this.showBtnBox = false
        }
        this.$forceUpdate()
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeOut)
  }
}
</script>

<style scoped>
.fileArea {
  position: relative;
}

.fileBox {
  width: 200px;
  height: 55px;
  display: flex;
  align-items: center;
}

.fileIcon {
  width: 30px;
  margin-left: auto;
}

.fileSize {
  color: #adacac;
  font-size: 12px;
}

.imgMsgFile {
  width: 150px;
}

.btnArea {
  position: absolute;
  left: -10px;
  bottom: -50px;
  z-index: 999;
}

.fileName {
  color: black;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/attachment.vue